import { stringifyArray } from '../utils/index.js';
/**
 * @param {Record<string} cache
 * @returns {SearchCache}
 */
export function SearchCache(cache = {}) {
    let searchCache = cache;
    return {
        getEntry: function (key) {
            if (searchCache[key]) {
                try {
                    return JSON.parse(searchCache[key]);
                }
                catch {
                    return undefined;
                }
            }
            return undefined;
        },
        formatKey: function (components) {
            return stringifyArray(components);
        },
        setEntry: function (key, searchResponse) {
            searchCache[key] = JSON.stringify(searchResponse);
        },
        clearCache: function () {
            searchCache = {};
        },
    };
}
//# sourceMappingURL=search-cache.js.map